import { AxiosInstance, AxiosResponse } from 'axios';

export interface NetworkEventQuery {
    tenantId: number;
    eventType?: string;
    state?: string;
    isActive?: string;
    since?: string;
    until?: string;
    limit?: number;
    offset?: number;
    order?: 'asc' | 'desc';
}

export function fetchNetworkEvents(
    api: AxiosInstance,
    params: NetworkEventQuery
): Promise<AxiosResponse> {
    const query = new URLSearchParams();
    query.set('tenantId', String(params.tenantId));
    query.set('includeChildServices', 'true');
    if (params.eventType) query.set('eventType', params.eventType);
    if (params.state) query.set('state', params.state);
    if (params.isActive) query.set('isActive', params.isActive);
    if (params.since) query.set('since', params.since);
    if (params.until) query.set('until', params.until);
    if (params.limit) query.set('limit', String(params.limit));
    if (params.offset !== undefined) query.set('offset', String(params.offset));
    if (params.order) query.set('order', params.order);
    return api.get(`/kontroledge/network-events?${query.toString()}`);
}

export interface NetworkIncidentQuery {
    tenantId: number;
    eventType?: string;
    isActive?: string;
    since?: string;
    until?: string;
    limit?: number;
    cursor?: string;
    order?: 'asc' | 'desc';
}

export function fetchNetworkIncidents(
    api: AxiosInstance,
    params: NetworkIncidentQuery
): Promise<AxiosResponse> {
    const query = new URLSearchParams();
    query.set('tenantId', String(params.tenantId));
    query.set('includeChildServices', 'true');
    if (params.eventType) query.set('eventType', params.eventType);
    if (params.isActive) query.set('isActive', params.isActive);
    if (params.since) query.set('since', params.since);
    if (params.until) query.set('until', params.until);
    if (params.limit) query.set('limit', String(params.limit));
    if (params.cursor) query.set('cursor', params.cursor);
    if (params.order) query.set('order', params.order);
    return api.get(`/kontroledge/network-events/incidents?${query.toString()}`);
}

export interface NetworkEventsCountParams {
    tenantId: number;
}

/** Documented shape for GET `/kontroledge/network-events/count`. */
export interface NetworkEventsCountApiResponse {
    success: boolean;
    message: string;
    data: { active: number };
}

export function parseNetworkEventsActiveCount(body: unknown): number | null {
    let parsed: unknown = body;
    if (typeof body === 'string') {
        try {
            parsed = JSON.parse(body) as unknown;
        } catch {
            return null;
        }
    }
    if (typeof parsed !== 'object' || parsed === null) return null;
    const data = (parsed as { data?: unknown }).data;
    if (typeof data !== 'object' || data === null) return null;
    const active = (data as { active?: unknown }).active;
    if (typeof active !== 'number' || !Number.isFinite(active) || active < 0) {
        return null;
    }
    return Math.floor(active);
}

/** GET `/kontroledge/network-events/count` (tenantId + includeChildServices). */
export function fetchNetworkEventsCount(
    api: AxiosInstance,
    params: NetworkEventsCountParams
): Promise<AxiosResponse<NetworkEventsCountApiResponse>> {
    const query = new URLSearchParams();
    query.set('tenantId', String(params.tenantId));
    query.set('includeChildServices', 'true');
    return api.get(`/kontroledge/network-events/count?${query.toString()}`);
}
